export const flaticonNormalIcons = [
    {   
        id: 1,
        label:'Book',
        url:'https://www.flaticon.com/free-icons/book',
        description:'created by mikan933',
        image:'./images/book.png',
    },
    {   
        id: 2,
        label:'Refer',
        url:'https://www.flaticon.com/free-icons/refer',
        description:'created by Freepik',
        image:'./images/refer.png',
    },
    {
        id: 3,
        label:'Fullscreen',
        url:'https://www.flaticon.com/free-icons/fullscreen',
        description:'created by mavadee',
        image:'./images/fullscreen.png',
    },
    {
        id: 4,
        label:'Livestock',
        url:'https://www.flaticon.com/free-icons/animals',
        description:'created by Eucalyp',
        image:'./images/livestock.png',
    },
    {
        id: 5,
        label:'Fruit',
        url:'https://www.flaticon.com/free-icons/fruit',
        description:'created by Freepik',
        image:'./images/fruit.png',
    },
]

export const flaticonAnimatedAnimalIcons = [
    {
        id: 6,
        label:'Fish',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/fish-static.png',
    },
    {
        id: 7,
        label:'Bird',
        url:'https://www.flaticon.com/free-animated-icons/bird',
        description:'created by Freepik',
        image:'./images/bird-static.png',
    },
    {
        id: 8,
        label:'Butterfly',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/butterfly-static.png',
    },
    {
        id: 9,
        label:'Frog',
        url:'https://www.flaticon.com/free-animated-icons/frog',
        description:'created by Freepik',
        image:'./images/frog-static.png',
    },
    {
        id: 10,
        label:'Monkey',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/monkey-static.png',
    },
    {
        id: 11,
        label:'Dog',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/dog-static.png',
    },
    {
        id: 12,
        label:'Penguin',
        url:'https://www.flaticon.com/free-animated-icons/penguin',
        description:'created by Freepik ',
        image:'./images/penguin-static.png',
    },
    {
        id: 13,
        label:'Rabbit',
        url:'https://www.flaticon.com/free-animated-icons/rabbit',
        description:'created by Freepik',
        image:'./images/rabbit-static.png',
    },
    {
        id: 14,
        label:'Snake',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/snake-static.png',
    },
    {
        id: 13,
        label:'Pig',
        url:'https://www.flaticon.com/free-animated-icons/pig',
        description:'created by Freepik',
        image:'./images/pig-static.png',
    },
    {
        id: 14,
        label:'Squirrel',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/squirrel-static.png',
    },
    {
        id: 15,
        label:'Bee',
        url:'https://www.flaticon.com/free-animated-icons/bee',
        description:'created by Freepik',
        image:'./images/bee-static.png',
    },
    {
        id: 16,
        label:'Camel',
        url:'https://www.flaticon.com/free-animated-icons/camel',
        description:'created by Freepik',
        image:'./images/camel-static.png',
    },
    {
        id: 17,
        label:'Cow',
        url:'https://www.flaticon.com/free-animated-icons/cow',
        description:'created by Freepik',
        image:'./images/cow-static.png',
    },
    {
        id: 18,
        label:'Elephant',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/elephant-static.png',
    },
    {
        id: 19,
        label:'Lion',
        url:'https://www.flaticon.com/free-animated-icons/lion',
        description:'created by Freepik',
        image:'./images/lion-static.png',
    },
    {
        id: 20,
        label:'Dolphin',
        url:'https://www.flaticon.com/free-animated-icons/dolphin',
        description:'created by Freepik',
        image:'./images/dolphin-static.png',
    },
    {
        id: 21,
        label:'Cat',
        url:'https://www.flaticon.com/free-animated-icons/animals',
        description:'created by Freepik',
        image:'./images/cat-static.png',
    },]

export const flaticonAnimatedFruitIcons = [
    {
        id: 22,
        label:'Apple',
        url:'https://www.flaticon.com/free-animated-icons/fruits',
        description:'created by Freepik',
        image:'./images/apple-static.png',
    },
    {
        id: 23,
        label:'Watermelon',
        url:'https://www.flaticon.com/free-animated-icons/watermelon',
        description:'created by Freepik',
        image:'./images/watermelon-static.png',
    },
    {
        id: 24,
        label:'Banana',
        url:'https://www.flaticon.com/free-animated-icons/fruit',
        description:'created by Freepik',
        image:'./images/banana-static.png',
    },
    {
        id: 25,
        label:'Mango',
        url:'https://www.flaticon.com/free-animated-icons/mango',
        description:'created by Freepik',
        image:'./images/mango-static2.png',
    },
    {
        id: 26,
        label:'Cherry',
        url:'https://www.flaticon.com/free-animated-icons/fruits',
        description:'created by Freepik',
        image:'./images/cherry-static.png',
    },
    {
        id: 27,
        label:'Lemon',
        url:'https://www.flaticon.com/free-animated-icons/lemon',
        description:'created by Freepik',
        image:'./images/lemon-static.png',
    },
    {
        id: 28,
        label:'Strawberry',
        url:'https://www.flaticon.com/free-animated-icons/strawberry',
        description:'created by Freepik',
        image:'./images/strawberry-static.png',
    },
    {
        id: 29,
        label:'Grape',
        url:'https://www.flaticon.com/free-animated-icons/grape',
        description:'created by Freepik',
        image:'./images/grape-static.png',
    },
    {
        id: 30,
        label:'Kiwi',
        url:'https://www.flaticon.com/free-animated-icons/kiwi',
        description:'created by Freepik',
        image:'./images/kiwi-static.png',
    },
    {
        id: 31,
        label:'Tangerine',
        url:'https://www.flaticon.com/free-animated-icons/fruit',
        description:'created by Freepik',
        image:'./images/tangerine-static.png',
    },
    {
        id: 32,
        label:'Dates',
        url:'https://www.flaticon.com/free-animated-icons/ramadan',
        description:'created by Freepik',
        image:'./images/dates-static.png',
    },
    {
        id: 33,
        label:'Avocado',
        url:'https://www.flaticon.com/free-animated-icons/avocado',
        description:'created by Freepik',
        image:'./images/avocado-static.png',
    },
    {
        id: 34,
        label:'Pineapple',
        url:'https://www.flaticon.com/free-animated-icons/pineapple',
        description:'created by Freepik',
        image:'./images/pineapple-static.png',
    },
    {
        id: 35,
        label:'Raspberry',
        url:'https://www.flaticon.com/free-animated-icons/fruits',
        description:'created by Freepik',
        image:'./images/raspberry-static.png',
    },
    {
        id: 36,
        label:'Coconut',
        url:'https://www.flaticon.com/free-animated-icons/food-and-restaurant',
        description:'created by Freepik',
        image:'./images/coconut-static.png',
    },
    {
        id: 37,
        label:'Orange',
        url:'https://www.flaticon.com/free-animated-icons/orange',
        description:'created by Freepik',
        image:'./images/orange-static.png',
    },
    {
        id: 38,
        label:'Fig',
        url:'https://www.flaticon.com/free-animated-icons/fig',
        description:'created by Freepik',
        image:'./images/fig-static.png',
    },
    {
        id: 39,
        label:'Pear',
        url:'https://www.flaticon.com/free-animated-icons/fruit',
        description:'created by Freepik',
        image:'./images/pear-static.png',
    },
]